import React, { useCallback, useEffect } from "react";

import GSTC from "gantt-schedule-timeline-calendar";
import "gantt-schedule-timeline-calendar/dist/style.css";

let gstc;
export default function GSTCWrapper(props) {
  
  let state = GSTC.api.stateFromConfig(props.config);

  if(props.onState){
    props.onState(state);
  }

  const callback = useCallback(
    node => {
      if (node) {
        gstc = GSTC({
          element: node,
          state
        });

        if(props.onInit){
            props.onInit(gstc);
        }
      }
    },
    [state, props]
  );

  useEffect(() => {
    return () => {
      if (gstc) {
        gstc.app.destroy();
      }
    };
  });

  return <div ref={callback} />;
}